const _get = async (endpoint) => {
    var res = false;
    if (navigator.onLine) {
        try {
            res = await fetch(endpoint, {
                method: "GET",
                header: {
                    "Access-Control-Allow-Origin": "GET",
                },
            })
        }
        catch (error) {
            alert("The server must be off. Please contact company.");
        }
        if (res) {
            const data = await res.json();
            return data;
        }
    }
    else {
        alert("Please connect to the internet.");
    }
}
export default _get


